import { apiSlice } from "../api/apiSlice";

export const addToCartApi = apiSlice.injectEndpoints({
  tagTypes: ["AddCartData", "AllOrders"],
  endpoints: (builder) => ({
    //get all add to cart data by email address
    getAddToCartDataByEmail: builder.query({
      query: (email) => ({
        url: `/cart/myCart/${email}`,
        method: "GET",
      }),
      providesTags: ["AddCartData"],
    }),

    addToCartNewDataByEmail: builder.mutation({
      query: ({ userEmail, data }) => ({
        url: `/cart/cartAdd/${userEmail}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["AddCartData"],
    }),
    deleteCardDataByEmailId: builder.mutation({
      query: ({ productId, userEmail }) => ({
        url: `/cart/cartEdit/${userEmail}`,
        method: "DELETE",
        body: productId,
      }),
      invalidatesTags: ["AddCartData"],
    }),

    //get all products
    getAllOrderByEmail: builder.query({
      query: () => ({
        url: `/order`,
        method: "GET",
      }),
    }),

    //post single order by email
    placeSingleOrderByEmail: builder.mutation({
      query: ({ userEmail, data2 }) => ({
        url: `/order/${userEmail}`,
        method: "POST",
        body: data2,
      }),
      invalidatesTags: ["AddCartData", "AllOrders"],
    }),

    //post single order by email
    placeSingleOrderSslCommerz: builder.mutation({
      query: ({ userEmail, data2 }) => ({
        url: `/order/${userEmail}`,
        method: "POST",
        body: data2,
      }),
      invalidatesTags: ["AddCartData", "AllOrders"],
    }),

    // order api here for performance

    //get all orders by user email
    getAllOrdersByEmail: builder.query({
      query: (userEmail) => ({
        url: `/order/user/${userEmail}`,
        method: "GET",
      }),
      providesTags: ["AllOrders"],
    }),
  }),
});

export const {
  useGetAllOrdersByEmailQuery,
  useGetAllOrderByEmailQuery,
  usePlaceSingleOrderByEmailMutation,
  usePlaceSingleOrderSslCommerzMutation,
  useGetAddToCartDataByEmailQuery,
  useAddToCartNewDataByEmailMutation,
  useDeleteCardDataByEmailIdMutation,
} = addToCartApi;
